import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isExpanded", "heading", "children"];
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.js";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.js";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.js";
import { Type } from "../Type/index.js";
import { AccordionIcon } from "./Icon.js";
import { Title } from "./Title.js";
import { TitleText } from "./TitleText.js";
/**
* **AccordionTitle** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/AccordionTitle) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=4037:6872)
*
* Title of the accordion component, seen on open and closed views.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/accordion)
*
* @example
* No example for this component
*
*/
export var AccordionTitle = /*#__PURE__*/React.forwardRef(function AccordionTitle(_ref, ref) {
  var _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? 'h2' : _ref$heading,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(Type, {
    as: heading,
    ref: ref
  }, /*#__PURE__*/React.createElement(Title, Object.assign({
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    "aria-expanded": isExpanded
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.AccordionTitle
  }), /*#__PURE__*/React.createElement(TitleText, {
    variant: "celloCanon"
  }, children), /*#__PURE__*/React.createElement(AccordionIcon, {
    isExpanded: isExpanded,
    semanticColor: "textSubdued",
    "aria-hidden": "true",
    role: "presentation"
  })));
});